import { MobileStickyBar } from "../shell/MobileStickyBar";
import { VaultActionsPanel, type VaultActionItem } from "./VaultActionsPanel";

export type { VaultActionItem };

interface VaultActionSheetProps {
  selectedItems: VaultActionItem[];
  tradingOn: boolean;
  creditsEnabled: boolean;
  onClear: () => void;
  onTradeCreated: () => void;
}

export function VaultActionSheet({
  selectedItems,
  tradingOn,
  creditsEnabled,
  onClear,
  onTradeCreated,
}: VaultActionSheetProps) {
  const selectedIds = selectedItems.map((i) => i.id);

  return (
    <MobileStickyBar active={selectedIds.length > 0}>
      <VaultActionsPanel
        selectedItems={selectedItems}
        tradingOn={tradingOn}
        creditsEnabled={creditsEnabled}
        onClear={onClear}
        onTradeCreated={onTradeCreated}
      />
    </MobileStickyBar>
  );
}
